import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { AuthModal } from './AuthModal';
import { LoadingScreen } from './LoadingScreen';
import { initializeDemoSearches } from '../../services/demoLocations';

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (user) {
      initializeDemoSearches(user.id);
    }
  }, [user]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-[var(--primary-bg)] flex items-center justify-center">
        <div className="w-full max-w-md">
          <AuthModal onClose={() => {}} />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}